"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localizeGridFuturesTrend = exports.useGridV4FuturesRecommendAI = exports.useGridV4FuturesAI = exports.useSymbolForFuturesMode = exports.parsePriceForModePure = exports.parsePriceForMode = void 0;
const react_1 = require("react");
const TradeAPILib_1 = require("TradeAPILib");
const apis_1 = require("../apis");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../../interface/interface");
const lodash_1 = require("lodash");
const trade_quotation_lib_1 = require("trade_quotation_lib");
// https://pionex.atlassian.net/wiki/spaces/productdoc/pages/595460322
// 1. 对于大于等于300u的发财金订单，ai策略页也只展示5倍杠杆的策略，10倍和15倍杠杆的策略不露出
// 2. 对于100u<发财金<300u的发财金订单，ai策略页也只展示最多到10倍杠杆的策略
const filterAIOptions = (info, bonusInfo) => {
    if (!bonusInfo || bonusInfo.status !== interface_1.BotBonusStatus.un_use) {
        return info;
    }
    const local_info = Object.assign({}, info);
    const bonusAmount = new trade_utils_lib_1.SafeDecimal(bonusInfo.bonus_amount);
    // 设置足够大的默认值从而不过滤AI选项
    let leverageLevel = 99999;
    if (bonusAmount.gte(300)) {
        leverageLevel = 5;
    }
    else if (bonusAmount.gt(100) && bonusAmount.lt(300)) {
        leverageLevel = 10;
    }
    local_info.options = info.options.filter((option) => {
        return new trade_utils_lib_1.SafeDecimal(option.leverage).lte(leverageLevel);
    });
    return local_info;
};
const parsePriceForMode = (price, symbol, mode) => {
    if ((typeof price !== "string" && typeof price !== "number") || !price || !symbol || (0, lodash_1.isUndefined)(symbol === null || symbol === void 0 ? void 0 : symbol.precision)) {
        return price;
    }
    if (mode && mode === TradeAPILib_1.GridFuturesMode.coin_m) {
        return new trade_utils_lib_1.SafeDecimal(1)
            .div(new trade_utils_lib_1.SafeDecimal(price))
            .toDecimalPlaces(symbol === null || symbol === void 0 ? void 0 : symbol.precision, trade_utils_lib_1.SafeDecimal.ROUND_DOWN)
            .toString();
    }
    return price;
};
exports.parsePriceForMode = parsePriceForMode;
// 获取反向币对的symbol, 不依赖symbol
const parsePriceForModePure = ({ price, precision = 0, mode = TradeAPILib_1.GridFuturesMode.normal, rounding = trade_utils_lib_1.SafeDecimal.ROUND_DOWN, }) => {
    if ((typeof price !== "string" && typeof price !== "number") || !price) {
        return price;
    }
    if (mode && mode === TradeAPILib_1.GridFuturesMode.coin_m) {
        return new trade_utils_lib_1.SafeDecimal(1).div(new trade_utils_lib_1.SafeDecimal(price)).toDecimalPlaces(precision, rounding).toString();
    }
    return price;
};
exports.parsePriceForModePure = parsePriceForModePure;
// 获取反向币对的symbol
const useSymbolForFuturesMode = (symbol, mode) => {
    const isCoinMode = mode === TradeAPILib_1.GridFuturesMode.coin_m;
    const [baseParseMode, quoteParseMode] = (0, react_1.useMemo)(() => {
        var _a;
        return [(symbol === null || symbol === void 0 ? void 0 : symbol.quote) + ".PERP", (_a = symbol === null || symbol === void 0 ? void 0 : symbol.base) === null || _a === void 0 ? void 0 : _a.split(".")[0]];
    }, [symbol === null || symbol === void 0 ? void 0 : symbol.base, symbol === null || symbol === void 0 ? void 0 : symbol.quote]);
    const symbolParseMode = (0, trade_quotation_lib_1.useSymbol)(baseParseMode, quoteParseMode);
    if (!isCoinMode || !symbol) {
        return symbol;
    }
    return symbolParseMode !== null && symbolParseMode !== void 0 ? symbolParseMode : symbol;
};
exports.useSymbolForFuturesMode = useSymbolForFuturesMode;
const useGridV4FuturesAI = (base, quote, trend, bonusInfo, mode) => {
    const [info, setInfo] = (0, react_1.useState)();
    const [error, setError] = (0, react_1.useState)();
    const [loading, setLoading] = (0, react_1.useState)(true);
    const symbolOri = (0, trade_quotation_lib_1.useSymbol)(base, quote);
    const symbol = (0, exports.useSymbolForFuturesMode)(symbolOri, mode);
    (0, react_1.useEffect)(() => {
        setInfo(undefined);
        setError(undefined);
        setLoading(true);
        const sub = (0, apis_1.gridV4FuturesAI)({ base, quote, trend }).subscribe({
            next: (res) => {
                if (res && res.length) {
                    let info = filterAIOptions(res[0], bonusInfo);
                    if (mode === TradeAPILib_1.GridFuturesMode.coin_m) {
                        info.options.forEach((option) => {
                            option.low_for_ui = (0, exports.parsePriceForMode)(option.high, symbol, mode);
                            option.high_for_ui = (0, exports.parsePriceForMode)(option.low, symbol, mode);
                        });
                    }
                    else {
                        info.options.forEach((option) => {
                            option.low_for_ui = option.low;
                            option.high_for_ui = option.high;
                        });
                    }
                    setInfo(info);
                }
                setLoading(false);
            },
            error: (err) => {
                setError(err);
                setLoading(false);
            },
        });
        return () => sub.unsubscribe();
    }, [base, quote, trend, filterAIOptions, mode]);
    return { info: info, error: error, loading: loading };
};
exports.useGridV4FuturesAI = useGridV4FuturesAI;
/**
 * 发财金跟单订单列表
 * @params {number} quote_investment 投资额，U
 * @params {number} limit 推荐的数量 默认10条
 */
const useGridV4FuturesRecommendAI = (params) => {
    const [info, setInfo] = (0, react_1.useState)([]);
    const [error, setError] = (0, react_1.useState)();
    const [loading, setLoading] = (0, react_1.useState)(true);
    const { quote_investment, limit } = params;
    if (typeof quote_investment !== "number") {
        return { info: [], error: undefined, loading: false };
    }
    (0, react_1.useEffect)(() => {
        setInfo([]);
        setError(undefined);
        setLoading(true);
        const retryOb = (0, trade_utils_lib_1.requestWithRetry)(() => (0, apis_1.gridV4FuturesRecommendAI)({ quote_investment: `${quote_investment}`, limit }), {
            maxRetryCount: 3,
        }).subscribe({
            next: (res) => {
                if (res && res.length) {
                    setInfo(res);
                }
                setLoading(false);
            },
            error: (error) => {
                setError(error);
                setLoading(false);
            },
        });
        return () => retryOb === null || retryOb === void 0 ? void 0 : retryOb.unsubscribe();
    }, [quote_investment, limit]);
    return { info: info, error: error, loading: loading };
};
exports.useGridV4FuturesRecommendAI = useGridV4FuturesRecommendAI;
const localizeGridFuturesTrend = (trend, $st) => {
    switch (trend) {
        case TradeAPILib_1.GridFuturesTrend.long:
            return $st("trade_trend_long");
        case TradeAPILib_1.GridFuturesTrend.short:
            return $st("trade_trend_short");
        case TradeAPILib_1.GridFuturesTrend.no_trend:
            return $st("trade_trend_null");
        default:
            return "--";
    }
};
exports.localizeGridFuturesTrend = localizeGridFuturesTrend;
